import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V7EmilyConversationAfter } from "./V7";

export const V7EmilyConversation = async (): Promise<any> => {
    ImageClass.setImage(images.v7.V7EmilyConv_0, { duration: 1 });
    mc.talk(`Hey, what's up?`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_1, partialsToDisplay: [images.v7.V7EmilyConv_1.partials.V7EmilyConv_1_p] });
    emily.talk(`Did you call for me?\nI swear I heard you while I was in the shower.`);
    if (Question.globalAnswers.v7EmilyShowerPeaked) {
        mc.think(`I'm glad that's the only thing she heard...`);

    } else {

    }
    ImageClass.setImage(images.v7.V7EmilyConv_1);
    mc.talk(`Oh. I just wanted to tell you that I met the new neighbor we talked about.`);
    ImageClass.setImage(images.v7.V7EmilyConv_4);
    if (mc.properties.annStatus === "gf") {
        emily.talk(`And? Did you tell Ann you are leaving her already?`);
        mc.talk(`Hey! Why do you say that?`);
        emily.talk(`Haha, relax I was just joking.`);
        ImageClass.setImage({ ...images.v7.V7EmilyConv_1, partialsToDisplay: [images.v7.V7EmilyConv_1.partials.V7EmilyConv_1_p] });
        emily.talk(`But seriously. I've seen her... It's hard to compete.`);
        emily.talk(`Anyway! What's she like?`);

    } else {
        emily.talk(`What's she like?`);

    }
    ImageClass.setImage(images.v7.V7EmilyConv_1);
    mc.talk(`She is nice... And I actually know her.`);
    emily.talk(`You do? Where from?`);
    mc.talk(`I'm following her on Insta.`);
    if (mc.properties.alexKnowsMC) {
        mc.talk(`And I've met her before. She is friend of Ann's... Small world.`);
        ImageClass.setImage(images.v7.V7EmilyConv_4);
        emily.talk(`Wow! Really small!`);


    } else {
        ImageClass.setImage(images.v7.V7EmilyConv_4);
        emily.talk(`Wow! Small world!`);
    }
    ImageClass.setImage(images.v7.V7EmilyConv_1);
    mc.talk(`Yeah... She's actually renting the house thanks to her Insta.`);
    ImageClass.setImage(images.v7.V7EmilyConv_1.partials.V7EmilyConv_1_p);
    emily.talk(`What? No way, you make that much money out of that?`);
    emily.talk(`I bet she does other kinky stuff behind the scenes that you don't know about.`);
    ImageClass.setImage(images.v7.V7EmilyConv_1);
    mc.talk(`Mmm... I don't think so... But I honestly don't know.`);
    mc.think(`But now I'm curious. Google search later maybe...`);
    ImageClass.setImage(images.v7.V7EmilyConv_3);
    emily.talk(`Well. Good for you, now you have another girl to chase after.`);
    mc.talk(`Hey now... What's going on?`);
    emily.talk(`I'm sorry. I guess this is hitting close to home for me. You know. About my ex.`);
    mc.talk(`Do you want to talk about it?`);
    mc.think(`Maybe I can get her to open up about the break-up.`);
    ImageClass.setImage(images.v7.V7EmilyConv_7, { duration: 1.2 });
    emily.talk(`I didn't mean to be dramatic...`);
    emily.talk(`I was just imagining how you'd chase after the neighbor and it reminded me how my ex chased after me.`);
    emily.talk(`I used to wake up every morning to a text he had sent me.`);
    emily.talk(`He kept sending flowers to my doorstep with a new card at least once a week.`);
    emily.talk(`You know, stupid small gestures that makes a girl happy and feel loved.`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_7, partialsToDisplay: [images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p] });
    mc.talk(`Sounds like you miss him.`);

    ImageClass.setImage({ ...images.v7.V7EmilyConv_5, partialsToDisplay: [images.v7.V7EmilyConv_5.partials.V7EmilyConv_5_p] });
    emily.talk(`It's a break-up, someone that denys it is a liar.`);
    emily.talk(`But does that mean that I want to get back to him?`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_5, partialsToDisplay: [images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p] });
    emily.talk(`Absolutely not.`);
    mc.talk(`You ready to talk about the break-up?`);
    ImageClass.setImage(images.v7.V7EmilyConv_7);
    emily.talk(`...Not yet... But soon.`);
    emily.talk(`He still hasn't stopped texting me since the last time I mentioned him.`);
    ImageClass.setImage(images.v7.V7EmilyConv_5);
    emily.talk(`He wants to come over.`);
    ImageClass.setImage(images.v7.V7EmilyConv_5.partials.V7EmilyConv_5_p);
    emily.talk(`I keep ignoring him... He'll get the hint eventually.`);
    ImageClass.setImage(images.v7.V7EmilyConv_5);
    mc.talk(`Do you want him to come?`);
    ImageClass.setImage(images.v7.V7EmilyConv_5.partials.V7EmilyConv_5_p);
    if (Question.globalAnswers.v1EnableNTR) {
        emily.talk(`I don't know... I guess not.`);
        if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
            mc.think(`...`);

        } else if (Question.globalAnswers.v7InvitedEmilysEx === "refused") {
            mc.think(`I guess I made the right choice.\nI did what she didn't have the courage to do.`);
        }

    } else {
        emily.talk(`No.`);

    }

    ImageClass.setImage(images.v7.V7EmilyConv_5);
    mc.talk(`I just hope he won't show up without an invitation.`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_5, partialsToDisplay: [images.v7.V7EmilyConv_5.partials.V7EmilyConv_5_p] });
    emily.talk(`He is a lot of things, but he wouldn't do that.`);
    if (Question.globalAnswers.v7InvitedEmilysEx === "invited") {
        mc.think(`She'll be surprised once he shows up at our front door.`);

    } else if (Question.globalAnswers.v7InvitedEmilysEx === "refused") {
        mc.think(`Especially after my text.`);
    }
    ImageClass.setImage(images.v7.V7EmilyConv_7);
    emily.talk(`I hope I didn't ruin your day.`);
    ImageClass.setImage(images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p);
    mc.talk(`Don't be silly! Of course not.`);
    mc.talk(`Why am I here if not to listen to you?`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_7, partialsToDisplay: [images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p_1] });
    emily.talk(`Haha, that's true.`);
    emily.talk(`I'm so lucky to have you.`);
    emily.talk(`When I got back I was scared you might have moved out already.`);
    ImageClass.setImage(images.v7.V7EmilyConv_7);
    emily.talk(`I'm real sorry I didn't kept in touch with you.`);
    emily.talk(`I should've called more often to see how you were doing.`);
    ImageClass.setImage({ ...images.v7.V7EmilyConv_7, partialsToDisplay: [images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p] });
    mc.talk(`I didn't call you as well... We are even.`);
    ImageClass.setImage(images.v7.V7EmilyConv_7.partials.V7EmilyConv_7_p_1);
    emily.talk(`Haha.`);
    emily.talk(`You always know how to make me feel better.`);

    emily.talk(`Ok! That's enough drama for one day.`);
    mc.talk(`I agree.`);
    ImageClass.setImage(images.v7.V7EmilyConv_10);
    emily.talk(`Can I at least get a hug?`);
    mc.talk(`Always!`);
    ImageClass.setImage(images.v7.V7EmilyConv_11, { duration: 1 });
    emily.talk(`${mc.name}.`, { method: "Whispering" });
    emily.talk(`Thanks for everything.`, { method: "Whispering" });


    return jump(V7EmilyConversationAfter, "V7EmilyConversationAfter");
};